export type ToastType = 'success' | 'error' | 'info'

export type ToastItem = {
  id: string
  type: ToastType
  message: string
}

type ToastListener = (toast: ToastItem) => void

let listener: ToastListener | null = null

export function registerToastListener(nextListener: ToastListener | null) {
  listener = nextListener
}

function emit(type: ToastType, message: string) {
  if (!message.trim()) {
    return
  }

  listener?.({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    message,
  })
}

/** Imperative toast API — used by the API client and pages. */
export const toast = {
  success(message: string) {
    emit('success', message)
  },
  error(message: string) {
    emit('error', message)
  },
  info(message: string) {
    emit('info', message)
  },
}
